function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2b6ed447-0bfc-43b9-9555-4888ec7768a9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.2 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-fac57cbb-a564-43bd-84f4-3cfc6da510d0"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 10,
    x2: 242.2,
    y2: 10,
    style: {
      fill: "none",
      stroke: "currentcolor",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 83,
    x2: 242.2,
    y2: 83,
    style: {
      fill: "none",
      stroke: "currentcolor",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 156,
    x2: 242.2,
    y2: 156,
    style: {
      fill: "none",
      stroke: "currentcolor",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.10f427c6afc3562c42312ef1e0ac410f.svg";
export { ForwardRef as ReactComponent };